<template lang="pug">
    .wrapper
        nav.nav
            div
            div
            button.button__action(
                @click="toggleCreateMediaLibraryModal"
                to="/products/create"
            ) Create New Media Library
        LibraryGrid
            .view-explanation
                h1 Media Libraries
            button.box(
                @click="toggleCreateMediaLibraryModal"
                v-if="!getMediaLibraries.length"
            ) Create a New Media Library
            router-link.product-group__link(zx
                :key="`${mediaLibrary._id}`"
                v-for="mediaLibrary in getMediaLibraries"
                v-if="getMediaLibraries.length"
                :to="`/media-libraries/${mediaLibrary._id}`"
            )
                .product.box
                    h3 {{mediaLibrary.title}}
</template>
<script>
import LibraryGrid from '../general/LibraryGrid';
import Services from '../../services/Services';
import store from '../../store';
export default {
  name: 'MediaLibraryLibrary',
  components: {
    LibraryGrid
  },
  computed: {
    getMediaLibraries() {
      return store.getters.getAllMediaLibraries;
    },
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  updated() {
    store.commit('setActiveLocale', null);
  },
  mounted() {
    Services.getMediaLibraries();
    Services.getMarkets();
  },
  methods: {
    toggleCreateMediaLibraryModal() {
      return store.commit('showCreateMediaLibraryModal', true);
    }
  }
};
</script>
<style lang="scss" scoped>
.product-group__link {
  padding: 0 2rem 2%;
  text-decoration: none;
  max-width: 460px;
  min-width: 300px;
  width: 25%;

  @media all and(max-width:640px) {
    width: 100%;
  }

  &:first-child {
    padding-left: 0;
  }
}
.box {
  margin: auto;
  border: 1px dashed #ccc;
  color: #666;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &.product {
    border-style: solid;
    flex-direction: column;
    text-transform: capitalize;
    text-align: center;
    padding: 1.6rem;
    align-items: flex-end;
    text-decoration: none;
    width: 100%;

    h3 {
      width: 100%;
    }

    .image__container {
      overflow: hidden;
    }

    img {
      margin: auto;
      max-width: 100%;
    }
  }

  &:hover {
    border-color: rgb(1, 168, 220);
    color: #073262;
    cursor: pointer;
  }
}

.button__action,
.box {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/views/MediaLibraryLibrary.vue